import { useNavigate } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import { PolicySettings, type PolicySettingRow } from "@studio-features/meta-crew/policy-settings";
import { api, errorMessage } from "../lib/api";
import { can } from "../lib/access";
import { keys, useSettings } from "../lib/queries";
import type { Me } from "../lib/types";
import { Loading, PanelError } from "../console/ui";

/**
 * 시스템 설정 › 요금·제재 정책 — 시안 05be2fc(요청서 23절) PolicySettings 에 실제 설정 API 를 잇는 어댑터.
 * 값·기본값은 GET /admin/settings 그대로, 저장은 PUT /admin/settings/:key 뒤 다시 읽는다.
 * 서버 설정 정의(zod)가 최종 검증이며, 실패하면 시안이 서버 문구를 그 행에 보여 주고 입력을 남긴다.
 */
export function SettingsScreen({ me }: { me: Me }) {
  const q = useSettings();
  const qc = useQueryClient();
  const navigate = useNavigate();
  const editable = can(me, "BILLING_MANAGE");
  if (q.isLoading) return <Loading />;
  if (q.error || !q.data) return <PanelError error={errorMessage(q.error)} onRetry={() => void q.refetch()} />;
  return (
    <PolicySettings
      view={{ settings: q.data as PolicySettingRow[], editable }}
      canEdit={editable}
      onSave={
        editable
          ? async (key, value) => {
              try {
                await api.put(`/admin/settings/${key}`, { value });
              } catch (e) {
                throw new Error(errorMessage(e));
              }
              await qc.invalidateQueries({ queryKey: [...keys.settings] });
            }
          : undefined
      }
      onOpenAiKeys={() => void navigate({ to: "/admin/$screen", params: { screen: "ai-keys" } })}
    />
  );
}
